import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import unescapedText from 'I18n/utils/unescapedText';
import { ACTION_TYPE_ICON_MAP, MAX_VISIBLE_ICONS } from './constants/icon-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_ENTRY = {
  icon: SprocketIcon,
  iconColor: 'fill-accent-neutral-default',
  backgroundColor: 'fill-accent-neutral-subtle-alt'
};
function getActionTypeEntry(actionType) {
  var _ACTION_TYPE_ICON_MAP;
  return (_ACTION_TYPE_ICON_MAP = ACTION_TYPE_ICON_MAP[actionType]) !== null && _ACTION_TYPE_ICON_MAP !== void 0 ? _ACTION_TYPE_ICON_MAP : DEFAULT_ENTRY;
}
function getActionTypeLabel(actionType) {
  return unescapedText(`marketplace-ui-common.workflowTemplates.actionTypes.${actionType}`);
}
export function WorkflowTemplateIconGroup({
  workflowActionTypes,
  maxIcons = MAX_VISIBLE_ICONS
}) {
  if (!workflowActionTypes.length) {
    return null;
  }

  // Deduplicate action types that resolve to the same category icon,
  // matching automation-studio-intro-ui-lib's deduplication by category.
  const seenIcons = new Set();
  const deduped = [];
  for (const actionType of workflowActionTypes) {
    const {
      icon
    } = getActionTypeEntry(actionType);
    if (!seenIcons.has(icon)) {
      seenIcons.add(icon);
      deduped.push(actionType);
    }
  }
  const visibleTypes = deduped.slice(0, maxIcons);
  const remainingCount = deduped.length - visibleTypes.length;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    "aria-label": unescapedText('marketplace-ui-common.workflowTemplates.iconGroupLabel'),
    role: "group",
    children: [/*#__PURE__*/_jsx(Flex, {
      gap: "100",
      children: visibleTypes.map(actionType => {
        const {
          icon,
          iconColor,
          backgroundColor
        } = getActionTypeEntry(actionType);
        const label = getActionTypeLabel(actionType);
        return /*#__PURE__*/_jsx(Tooltip, {
          title: label,
          children: /*#__PURE__*/_jsx(IconHolder, {
            "aria-label": label,
            backgroundColor: backgroundColor,
            borderRadius: "200",
            color: iconColor,
            icon: icon,
            size: "100"
          })
        }, actionType);
      })
    }), remainingCount > 0 && /*#__PURE__*/_jsxs(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      "aria-label": unescapedText('marketplace-ui-common.workflowTemplates.moreActionTypes', {
        count: remainingCount
      }),
      children: ["+", remainingCount]
    })]
  });
}